import React, { useState } from "react";
import { Box, Group } from "@mantine/core";
import { Button } from "../Button/Button";
import DentalArchesSvg, { TeethChoice } from "../../components/DentalArchesSvg";
import { Legend } from "./legend/Legend";

export interface DentalSvgWithButtonsProps {
  teethChoices: TeethChoice[];
  onClick: (teeth: { name: string; teeth: number[] }[]) => void;
}

export const DentalSvgWithButtons = ({
  ...props
}: DentalSvgWithButtonsProps) => {
  const [selectedLabel, setSelectedLabel] = useState<string | null>(
    props.teethChoices[0].label
  );
  const [selectedTeeth, setSelectedTeeth] = useState<TeethChoice[]>(
    props.teethChoices
  );
  const [currentColor, setCurrentColor] = useState<string | null>(
    props.teethChoices[0].color
  );
  const handleClick = (tooth: number, label: string) => {
    const newSelectedTeethOfLabel = selectedTeeth.find(
      t => t.label === label
    ).teeth;
    const newSelectedTeeth = [...selectedTeeth];
    if (newSelectedTeethOfLabel.includes(tooth)) {
      newSelectedTeeth
        .find(t => t.label === label)
        .teeth.splice(newSelectedTeethOfLabel.indexOf(tooth), 1);
    } else {
      newSelectedTeeth
        .filter(t => t.label !== label)
        .forEach(t => {
          if (t.teeth.includes(tooth)) {
            t.teeth.splice(t.teeth.indexOf(tooth), 1);
          }
        });
      newSelectedTeeth.find(t => t.label === label).teeth.push(tooth);
    }
    setSelectedTeeth(newSelectedTeeth);
    props.onClick(
      newSelectedTeeth.map(t => ({ name: t.name, teeth: t.teeth }))
    );
  };
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Group>
        <DentalArchesSvg
          {...props}
          newSelectionColor={currentColor}
          teeth={selectedTeeth}
          onClick={tooth => {
            handleClick(tooth, selectedLabel);
          }}
        />
        <Legend teethChoices={props.teethChoices} />
      </Group>
      <Group
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {props.teethChoices.map(t => (
          <Button
            key={`button-${t.key}`}
            variant={t.label === selectedLabel ? undefined : "outline"}
            onClick={() => {
              setSelectedLabel(t.label);
              setCurrentColor(t.color);
            }}
          >
            {t.label}
          </Button>
        ))}
      </Group>
    </Box>
  );
};
